<template>
  <b-badge pill
           :variant="variant"
           class="badge--custom"
           :class="`badge--text-${textColour} badge--font-weight-${fontWeight} badge--size-${size}`">
    <slot/>
  </b-badge>
</template>

<script>
export default {
  name: 'Badge',
  props: {
    colour: {
      type: String,
      required: false,
      default: 'white',
      validate: (value) => ['grey', 'white', 'primary', 'secondary'].includes(value),
    },
    textColour: {
      type: String,
      required: false,
      default: 'black',
      validate: (value) => ['grey', 'white', 'black', 'primary', 'secondary'].includes(value),
    },
    fontWeight: {
      type: String,
      required: false,
      default: 'bold',
      validate: (value) => ['normal', 'bold'].includes(value),
    },
    size: {
      type: String,
      required: false,
      default: 'medium',
      validate: (value) => ['small', 'medium', 'large'].includes(value),
    },
  },
  computed: {
    variant() {
      return {
        grey: 'dark',
        white: 'light',
        primary: 'primary',
        secondary: 'secondary',
      }[this.colour]
    },
  },
}
</script>
